import { render, staticRenderFns } from "./conservantes.vue?vue&type=template&id=4fa02d3e"
import script from "./conservantes.vue?vue&type=script&lang=js"
export * from "./conservantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports